export default __webpack_public_path__ + "static/media/fishfood3.3ba9cfcb.jpeg";